import { createStyles, Text, Stack, useMantineTheme } from '@mantine/core';
import { Mail, Phone, Printer } from 'tabler-icons-react';
import { GetTranslated, TranslateField } from '../types/translate-field';
import hbLogo from '../assets/image/hobbylobby.png'
import mardelLogo from '../assets/image/mardel.png'
import DefaultContainer from './container';
import { useTranslation } from 'react-i18next';

const useStyles = createStyles((theme) => ({
  footer: {
    marginTop: 0,
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
    borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]}`,
    zIndex: 1
  },

  logo: {
    maxWidth: '230px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: theme.spacing.xl,
    alignItems: 'start',
    margin: '0px 20px'
  },

  description: {
    marginTop: 5,

    [theme.fn.smallerThan('sm')]: {
      marginTop: theme.spacing.xs,
      textAlign: 'center',
    },
  },

  inner: {
    display: 'flex',
    margin: 'auto',
    maxWidth: theme.other.containerSize,
    alignItems: 'center',
    [theme.fn.largerThan('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    [theme.fn.smallerThan('md')]: {
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },

  groups: {
    display: 'flex',
    flexWrap: 'wrap',

    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  wrapper: {
    width: 160,
  },

  link: {
    display: 'block',
    color: theme.colorScheme === 'dark' ? theme.colors.dark[1] : theme.colors.gray[6],
    fontSize: theme.fontSizes.sm,
    paddingTop: 3,
    paddingBottom: 3,

    '&:hover': {
      textDecoration: 'underline',
    },
  },

  title: {
    fontSize: theme.fontSizes.lg,
    fontWeight: 700,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    marginBottom: theme.spacing.xs / 2,
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
  },

  afterFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing.xl,
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]}`,


    [theme.fn.smallerThan('md')]: {
      fontSize:'12px'
    },
    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
    },
  },

  social: {
    [theme.fn.smallerThan('sm')]: {
      marginTop: theme.spacing.xs,
    },
  },

  hover: {
    '&:hover': {
      cursor: 'pointer'
    }
  },

  footerItem: {
    display: 'flex',
    flexDirection: 'row',
    [theme.fn.smallerThan('md')]: {
      fontSize:'12px'
    },
  },

  contactText: {
    paddingLeft:'20px!important',
    [theme.fn.smallerThan('md')]: {
      fontSize:'12px',
      paddingLeft:'10px!important'
    },
  }
}));

const FooterBar = (props: { footerFields: TranslateField[], locale: string }) => {
  const { classes } = useStyles();
  const theme = useMantineTheme()
  const { t } = useTranslation('common', { keyPrefix: 'section' })
  const year = new Date().getFullYear()

  if (props.footerFields == undefined) {
    return <></>
  }
  return (
    <footer className={classes.footer}>
      <div className={classes.inner}>
        <div className={classes.logo}>
          <a href={'https://www.hobbylobby.com/'} style={{ width: 100, height: 100, backgroundColor:'#FFF', backgroundImage: `url(${hbLogo})`, backgroundSize: 'cover' }} target={'_blank'} className={classes.hover} />
          <a href={'https://www.mardel.com/'} style={{ width: 100, height: 100, backgroundColor:'#FFF', backgroundImage: `url(${mardelLogo})`, backgroundSize: 'cover', marginLeft: 30 }} target={'_blank'} className={classes.hover} />
        </div>
        <Stack>
          {props.footerFields.map(field => {
            return (
              <div className={classes.footerItem} key={field.key}>
                {
                  field.key == 'email_hk' ? <Mail color={theme.colors.hkc[2]} /> :
                    field.key == 'phone_hk' ? <Phone color={theme.colors.hkc[2]} /> :
                      <Printer color={theme.colors.hkc[2]} />
                }
                <Text className={classes.contactText} color={theme.colors.hkc[2]}>{`${field.key == 'email_hk' ? t('email') : ''}${GetTranslated(field, props.locale)}`}</Text>
              </div>)
          })}
        </Stack>
      </div>
      <DefaultContainer className={classes.afterFooter}>
        <Text color="dimmed" >
          Copyright © {year} Hobby Lobby All rights reserved.
          <br></br>
          © {year} Hong Kong Connections Ltd. 
          <br></br>
          (Member of the Hobby Lobby® family)
        </Text>
      </DefaultContainer>
    </footer>
  );
}

export default FooterBar